
<abp-loader-bar></abp-loader-bar>
<div *ngIf="showHideSpinner" id="lp-page-loader"></div>
<abp-dynamic-layout></abp-dynamic-layout>
